<template>
    <section>
        <b-container fluid class="bg-users">
            <b-list-group>
                <b-list-group-item href="https://docs.google.com/document/d/1DHl413x1VlSLk3gFI3A1L2RBeXmm-BOSY763Xve2u5Y/edit">Policy</b-list-group-item>
                <b-list-group-item href="https://docs.google.com/spreadsheets/d/1shNerIgHbVPSGEj1VLJV9UPjWOiie-ZFanQRqtrwobg/edit#gid=873027508">Personal data/ Tech skills NEW</b-list-group-item>
                <b-list-group-item href="https://docs.google.com/spreadsheets/d/1HdFxMTj7Cz98omLCvFiCExPOX1D7pv-sQsGgUHh6X_s/edit?usp=sharing">Vacations and sick days</b-list-group-item>
                <b-list-group-item href="https://docs.google.com/spreadsheets/d/1j3Z7FtZEv0SdPtWbJvpOnPXD6qzTKohFHbMbmQ-vLHw/edit#gid=0">Book wishes</b-list-group-item>

            </b-list-group>
        </b-container>
    </section>
</template>
<script>
export default {
  name: 'users-info-hr',
  data () {
    return {

    }
  },
  methods: {
  },
  mounted () {

  }
}
</script>

<style scoped>
    .bg-users {
        padding: 20px;
    }
</style>
